import React from 'react';
import { Button } from 'antd';

import { useWelcomeTour } from '../../contexts/WelcomeTourContext';

export const WELCOME_OFFER_TITLE = 'Take a 2-minute tour?';
export const WELCOME_OFFER_TEXT = 'A quick walk through the sidebar shows where things are. You can leave at any time, and take it again from your account menu.';

/**
 * The welcome tour's offer on Home (KPR-613, KPE-024): a calm panel asking
 * whether to take the tour, shown only to a person who has neither finished it
 * nor said no (at the version this build ships), and never over a progress read
 * that failed (`useWelcomeTour().offered`). It is offered, never forced: Start
 * runs the tour, Not now saves "dismissed" and the panel goes, on every device.
 *
 * A panel on the ground, not a banner: 1px border, no shadow. Start is the
 * default button, not a second filled primary beside Home's Add to Home, and
 * Not now is a text button, so the page keeps its one accent on its one primary.
 * Renders nothing while the answer is unknown or the person is not offered it.
 */
export default function WelcomeTourOffer() {
	const { offered, start, dismiss } = useWelcomeTour();
	if (!offered) return null;

	return (
		<section className="welcome-offer" aria-labelledby="welcome-offer-title" data-testid="welcome-tour-offer">
			<div className="welcome-offer__body">
				<h2 className="welcome-offer__title" id="welcome-offer-title">{WELCOME_OFFER_TITLE}</h2>
				<p className="welcome-offer__text">{WELCOME_OFFER_TEXT}</p>
			</div>
			<div className="welcome-offer__actions">
				<Button onClick={start}>Start</Button>
				<Button type="text" onClick={dismiss}>Not now</Button>
			</div>
		</section>
	);
}
